<template>
    <div class="card h-full p-4">
        <div class="mb-4 text-center">
            <avatar :user="user"></avatar>
        </div>
        <div class="text-center">
            <h4 class="text-base mb-1">{{ fullName }}</h4>
            <div>{{ user.email }}</div>
            <slot name="bottom"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    computed: {
        fullName() {
            return `${this.user.first_name} ${this.user.last_name}`;
        },
    },
};
</script>
